import { defineMessages } from 'react-intl';

export const messages: {
	browseWithDropzone: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uploadIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	browseWithDropzone: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.browse-with-dropzone',
		defaultMessage: 'Drop files to attach or <a>browse</a>',
		description: 'File upload prompt with drag-and-drop or browse options',
	},
	uploadIconLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.upload-icon-label',
		defaultMessage: 'Upload',
		description:
			'The accessible label for the upload icon button in the attachment field edit area of the form renderer, indicating the action to upload a file.',
	},
	deleteIconLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.delete-icon-label',
		defaultMessage: 'Delete',
		description:
			'The accessible label for the delete icon button in the attachment field edit area of the form renderer, indicating the action to remove an attached file.',
	},
});
